import { Navigate } from 'react-router-dom'
import { isRootAdmin } from '../../helpers/utils'
import { AppRoutes } from '../../helpers/routes'
import CustomPaper from '../../containers/Paper'
import CustomButton from '../../components/Button'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import CustomModal from '../../containers/Modal'
import { useState } from 'react'
import NewAdminForm from './NewAdminForm'
import AdminsTable from './AdminsTable'
import SettingsIcon from '@mui/icons-material/Settings'
import ConfigurationForm from './ConfigurationForm'

const AdminsPage = () => {
    const [isNewAdminModalOpen, setIsNewAdminModalOpen] = useState<boolean>(false)
    const [isConfigModalOpen, setIsConfigModalOpen] = useState<boolean>(false)

    return (
        <div className="w-full">
            {isRootAdmin() ? (
                <div>
                    <CustomPaper className="flex flex-col p-3 md:p-5 gap-2 md:gap-0">
                        <div className="flex justify-between items-center md:mb-4">
                            <span className="text-lg md:text-2xl text-primary font-semibold">
                                Administradores
                            </span>
                            <div className="flex flex-col md:flex-row gap-2 md:gap-4">
                                <CustomButton
                                    text="Crear administrador"
                                    onClick={() => setIsNewAdminModalOpen(true)}
                                    startIcon={<AddCircleOutlineIcon />}
                                    secondary
                                    className="text-xs md:text-base px-2 md:px-4"
                                />
                                <CustomButton
                                    text="Configurar universidad"
                                    onClick={() => setIsConfigModalOpen(true)}
                                    startIcon={<SettingsIcon />}
                                    secondary
                                    className="text-xs md:text-base px-2 md:px-4"
                                />
                            </div>
                        </div>
                        <AdminsTable />
                    </CustomPaper>
                </div>
            ) : (
                <Navigate to={AppRoutes.home} />
            )}
            <CustomModal
                isOpen={isNewAdminModalOpen}
                handleClose={() => setIsNewAdminModalOpen(false)}
            >
                <NewAdminForm handleClose={() => setIsNewAdminModalOpen(false)} />
            </CustomModal>
            <CustomModal
                isOpen={isConfigModalOpen}
                handleClose={() => setIsConfigModalOpen(false)}
            >
                <ConfigurationForm handleClose={() => setIsConfigModalOpen(false)} />
            </CustomModal>
        </div>
    )
}

export default AdminsPage
